import React, { Component } from 'react';
import QueryString from 'query-string';

import { Http } from '../../support';
import Loading from '../../facturotopia/loading/Loading';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';

class LandingCompraConfirm extends Component {

  state = {
    data: {}
  }

  componentDidMount = async () => {
    const { id } = this.props.match.params;

    const query = QueryString.parse(this.props.location.search);

    const intro = !!query.intro ? true : false;

    this.setState({
      busy: true,
      intro: intro
    });

    const param = {
      payment_intent: query.payment_intent,
    };

    try {
      const response = await Http.patch(`api/compras/${id}/confirmar`, param);

      this.setState({
        result: response
      });

    } catch (response) {
      this.setState({
        error: response.data || response
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnAction = async (action) => {
    if (action === 'reset') {
      const { id } = this.props.match.params;

      this.props.history.replace({
        pathname: `/cuenta/historial-compra/${id}/info`,
      });
    }

    if (action === 'success') {
      const { intro } = this.state;

      if (!!intro) {
        this.props.history.replace({
          pathname: `/app/intro`,
        });
      } else {
        this.props.history.replace({
          pathname: `/app/dashboard`,
        });
      }

    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Compra exitosa"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { busy, error, result } = this.state;

    return (
      <>
        { busy && <Loading /> }

        { busy && (
          <div className="py-5">
            <strong>Procesando tu compra, por favor espera</strong>
          </div>
        )}

        { !!result && this.renderResult() }

        { !!error && this.renderError() }
      </>
    )
  }
}

export default LandingCompraConfirm;